<template>
  <div class="main">
    <!-- <div class="banner">
      <div class="logo">
       Ramyat Call Meet
      </div>
    </div> -->
    <agora
      channel="channel"
      :autoStart="false"
      :errorHandler="errorHandler"
    >
      <agora-video-sender customizationPlayer @video-ready="handleVideoReady" :cameraOff="cameraOff" />
      <agora-audio-sender ref="audioSender" :mute="mute" @track-created="handleTrackCreated" />
    </agora>
    <div ref="cameraArea" v-if="localVideoDirective" class="camera-area" :class="playerClass" v-player="localVideoDirective">
      <voice-dot class="voice-dot-local" :mute="mute" :level="level" />
      <mp-button-white class="mp-btn-local" :class="mpClass" @click="handleMpClick"></mp-button-white>
      <video-button-white class="video-btn-local" :class="videoClass" @click="handleVideoClick"></video-button-white>
    </div>
    <div ref="cameraArea" v-if="!localVideoDirective" class="camera-area" :class="playerClass">
      <voice-dot class="voice-dot-local" :mute="mute" :level="level" />
      <mp-button-white class="mp-btn-local" :class="mpClass" @click="handleMpClick"></mp-button-white>
      <video-button-white class="video-btn-local" :class="videoClass" @click="handleVideoClick"></video-button-white>
    </div>

    <div class="operation">
      <p class="question"> {{ $t('msg_start_meeting') }}</p>
      <!-- <p class="tip">Enjoy the meeting time</p> -->

      <b-button @click="handleJoin" variant="outline-secondary" class="btn-join-button" :disabled="isJoining">
        <span v-if="isJoining">
          <b-spinner small></b-spinner>
          <span>  {{ $t('joining_now') }}</span>
        </span>
        <span v-else>{{ $t('join_now') }}</span>
      </b-button>

      <!--       <div class="join-button"   @click="handleJoin">

      <span v-if="isJoining" class="">
  <Spinner v-if="isJoining" />
     

    </span>
   

    </div> -->
      <b-alert
        variant="warning"
        dismissible
        fade
        :show="errorMsg && errorMsg.length > 0"
        @dismissed="showDismissibleAlert = false"
      >
        {{ errorMsg }}
      </b-alert>
    </div>

    <div class="footer">
      <!--  <div class="desc">This is a demo for AgoraRtcVue</div>
      <div class="copyright">2021 Agora Inc. | All rights reserved</div> -->
    </div>
  </div>
</template>

<script>
import VoiceDot from "./voice-dot/main.vue";
import MpButtonWhite from "./buttons/mp-button-white";
import VideoButtonWhite from "./buttons/video-button-white";
//import Spinner from './pin-button/Spinner.vue';

import { BSpinner, BAlert, BButton, BImg } from "bootstrap-vue";
export default {
  name: "Main",
  components: {
    VoiceDot,
    BButton,
    BSpinner,
    BAlert,
    MpButtonWhite,
    VideoButtonWhite
    // BCol,
    //  BRow
  },
  props: {
    isJoining: {
      type: Boolean,
      default: false
    },
    errorMsg: {
      type: [String, null]
    },
    channel: {
      type: [String, null]
    },
    appid: {
      type: [String, null]
    },
    token: {
      type: [String, null]
    }
  },
  data() {
    return {
      localVideoDirective: null,
      mute: false,
      level: 0,
      cameraOff: false
    };
  },
  computed: {
    mpClass() {
      return this.mute ? "mp-mute" : "mp-normal";
    },
    videoClass() {
      return this.cameraOff ? "video-mute" : "video-normal";
    },
    playerClass() {
      return this.cameraOff ? "camera-off" : "";
    }
  },
  methods: {

     errorHandler(error) {
      // this.$message.error(error.message || error);
    },
    handleVideoReady(localVideo) {
      this.localVideoDirective = localVideo;
    },
    handleTrackCreated() {
      let id = undefined;
      const callback = () => {
        this.level = this.$refs.audioSender.getTrack().getVolumeLevel();
        id = window.requestAnimationFrame(callback);
      };
      id = window.requestAnimationFrame(callback);
      this.$once("hook:beforeDestroy", () => {
        window.cancelAnimationFrame(id);
      });
    },
    handleJoin() {
      this.$emit("join-meeting", {
        channel: this.channel,
        mute: this.mute,
        cameraOff: this.cameraOff
      });
    },
    handleMpClick() {
      this.mute = !this.mute;
     // this.$emit("mute-update",this.mute);
    },
    handleVideoClick() {
      this.cameraOff = !this.cameraOff;

      // this.$emit("camera-update",this.cameraOff);
    }
  }
};
</script>

<style scoped>
/*.join-button {
  padding: 12px 24px;
  font-size: 16px;
  border: none;
  background-color: #4285f4;
  color: white;
  transition: background-color 0.3s ease-in-out;
}*/

.join-button.joining {
  animation: rotate 1s linear infinite;
  background-color: #fbbc05;
}
.btn-join-button {
  display: block;
  margin: 0 auto;
  border-radius: 3em;
  text-align: center;
  background-color: #099dfd;
  color: #fff;
  font-size: 1em;
  cursor: pointer;
  margin-bottom: 10px;
  transition: background-color 0.3s ease-in-out;
}
@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@media (min-width: 800px) {
  .camera-area {
    position: absolute;
    top: 28vh;
    left: 8vw;
    width: 50vw;
    height: 50vh;
  }
  .operation {
    position: absolute;
    right: 10vw;
    top: 36vh;
    width: 24vw;
    height: 20vh;
    color: #000;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
  }
  .footer {
    position: absolute;
    bottom: 10px;
    left: 50%;
    font-size: 0.8em;
    transform: translateX(-50%);
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-direction: column;
  }
}

@media (max-width: 800px) {
  .camera-area {
    margin-top: 20px;
    position: relative;
  }
  .operation {
    position: relative;
  }
  .footer {
    position: relative;
  }
}
</style>
<style lang="stylus" scoped>
@import "../styles/main/index.styl"
</style>
